import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { actions } from '../store/reducers/assignment.reducer'
import { useParams } from 'react-router'
import useDebounce from './useDebounce'

const useProjectionCostEstimation = (arrayOfCriteria, shouldCallHook = true, llmVersion) => {
    const { token } = useParams()
    const [projectionCostDetails, setProjectionCostDetails] = useState('...')
    const dispatch = useDispatch()

    const debouncedEstimate = useDebounce(
        async () => {
            if (shouldCallHook && arrayOfCriteria) {
                setProjectionCostDetails('...')
                const cost = await dispatch(
                    actions.estimateProjectionCost(
                        token,
                        arrayOfCriteria,
                        message => setProjectionCostDetails(`(${message})`),
                        llmVersion,
                    ),
                )
                if (cost !== undefined) {
                    if (cost < 1) {
                        setProjectionCostDetails('')
                    } else if (cost) {
                        setProjectionCostDetails(`$${cost}`)
                    }
                }
            }
        },
        1000,
        [token, arrayOfCriteria, shouldCallHook, dispatch, llmVersion]
    )

    useEffect(() => {
        debouncedEstimate()
    }, [debouncedEstimate])

    return projectionCostDetails
}

export default useProjectionCostEstimation
